import { ArrowLeft } from 'lucide-react';
import { SOMMETS } from './decorRegions';

/**
 * « La Forêt des Mots » — scène d'attente (les générateurs français
 * n'existent pas encore) : canopée sous brume dérivante + message. La
 * version immersive complète (pendant du Volcan des Nombres) viendra
 * avec les défis de français.
 */
function ForetBrume({ region, onBack }) {
    const sommet = SOMMETS.foret;
    return (
        <div
            className="eleve-gamified fixed inset-0 z-[100] overflow-hidden flex flex-col"
            style={{ background: 'radial-gradient(120% 90% at 50% 110%, #0e2a1c 0%, #0d1f33 45%, #0A1F3D 100%)' }}
        >
            <div className="absolute inset-x-0 top-0 h-72 pointer-events-none" style={{ background: sommet.fond }} />

            <div className="relative flex items-center p-5">
                <button onClick={onBack} aria-label="Retour à l'île" className="p-2.5 rounded-xl text-white" style={{ background: 'rgba(255,255,255,.1)' }}>
                    <ArrowLeft className="w-5 h-5" />
                </button>
            </div>

            <div className="relative flex-1 flex flex-col items-center justify-center px-6 text-center -mt-10">
                <div className="relative w-full max-w-md">
                    <svg viewBox={sommet.viewBox} className="w-full h-auto block" aria-hidden="true">
                        {sommet.elements.map((el, i) => (
                            <path key={i} d={el.d} fill={el.fill} opacity={el.opacity} />
                        ))}
                    </svg>
                    {/* Brume dérivante sur la canopée */}
                    <svg className="absolute inset-x-0 bottom-0 w-full pointer-events-none" viewBox="0 0 320 70" aria-hidden="true">
                        <ellipse className="ile-mist" cx="100" cy="38" rx="95" ry="20" fill="rgba(255,255,255,.20)" style={{ filter: 'blur(7px)' }} />
                        <ellipse className="ile-mist" cx="230" cy="48" rx="85" ry="17" fill="rgba(255,255,255,.14)" style={{ filter: 'blur(7px)', animationDelay: '1.8s' }} />
                    </svg>
                </div>
                <h1 className="text-white text-2xl mt-4">{region.emoji} {region.nom}</h1>
                <p className="mt-2 text-sm font-bold max-w-xs" style={{ color: 'rgba(255,255,255,.65)' }}>
                    La forêt dort encore… C'est ici que vit Tano, et c'est ici que les
                    défis de français s'éveilleront. Reviens bientôt ✨
                </p>
            </div>
        </div>
    );
}

export default ForetBrume;
